<template>
  <div>
    <v-layout class="align-center" row wrap>
      <div v-if="item.isSuccess" style="flex: 1 0;">
        <template v-for="(dataType, i) in keysToDisplay">
          <v-tooltip :disabled="dataType.key != 'newResults'" :key="`${dataType.key}-${i}`" bottom>
            <template v-slot:activator="{ on }">
              <v-chip v-on="on" color="transparent" label class="mr-1">
                <v-avatar class="mr-0">
                  <v-icon color="secondary" class="no-transition">
                    {{ dataType.icon ? dataType.icon : getMediaTypeIcon(item.mediaType) }}
                  </v-icon>
                </v-avatar>
                <span class="headline font-weight-regular mr-2">
                  {{ item[dataType.key] }}
                </span>
                <span :class="{ 'grey--text text--darken-1': !hover }" class="" v-if="!isSurveyData">
                  New {{ pluralize(dataType.displayName, item[dataType.key]) }}
                </span>
              </v-chip>
            </template>
            <span><strong>{{ item.mediaType || 'Unknown' }}</strong> media type</span>
          </v-tooltip>
        </template>
      </div>
      <v-card-text v-else style="flex: 1 0;">
        Data ingestion failed. Review the file or view the logs for details.
      </v-card-text>
      <div>
        <div v-if="item.fileName" class="text-xs-right">
          <v-tooltip bottom :open-delay="300">
            <template v-slot:activator="{ on }">
              <v-btn v-if="item.executionId != null && item.isIngestion" :to="{ name: 'dataset', params: { id: item.fileId }}" v-on="on" depressed small>
                <!-- <v-chip  small label> -->
                <!-- <router-link :to="{ name: 'dataset', params: { id: item.fileId }}"> -->
                <v-icon class="mr-2">attach_file</v-icon>
                <span class="text-none">{{ item.fileName }}</span>
                <!-- </router-link> -->
                <!-- </v-chip> -->
              </v-btn>
              <v-btn v-else :href="'/uploads/' + item.FullName" download depressed small>
                <!-- <v-chip  small label> -->
                <!-- <router-link :to="{ name: 'dataset', params: { id: item.fileId }}"> -->
                <v-icon class="mr-2">attach_file</v-icon>
                <span class="text-none">{{ item.fileName }}</span>
                <!-- </router-link> -->
                <!-- </v-chip> -->
              </v-btn>
            </template>
            <span> File name </span>
          </v-tooltip>
        </div>
        <div v-if="item.cocCodes" class="text-xs-right">
          <v-tooltip bottom :open-delay="300">
            <template v-slot:activator="{ on }">
              <v-chip v-on="on" small label>
                <v-icon class="mr-2">link</v-icon>
                {{ item.cocCodes }}
              </v-chip>
            </template>
            <span> COC Code </span>
          </v-tooltip>
        </div>
      </div>
    </v-layout>
    <template v-if="rollbackItem">
      <v-card-title class="card-bg-2 py-0">
        <v-icon color="error" class="mr-2">error</v-icon>
        <span class="font-weight-medium">This import was rolled back</span>
        <TertiaryBtn :to="{ name: 'allimports', query: { search: rollbackItem.rollbackId } }" small icon="find_in_page">Go to rollback</TertiaryBtn>
      </v-card-title>
      <v-divider />
      <v-card-text class="py-0">
        <RollbackRun v-if="rollbackItem" :hover="hover" :item="rollbackItem" />
      </v-card-text>
    </template>
  </div>
</template>

<script>
  import { pluralize } from '@/helpers/strings'
  import { serviceKeys, surveyDataKeys } from '@/helpers/datasets/ingestions'
  import { getMediaTypeIcon } from '@/helpers/mediaTypes'
  import { SERVICE_LINKS } from '@/store/ServiceRegistry/linkedservices'
  export default {
    components: {
      // https://stackoverflow.com/a/58875919/12161614
      RollbackRun: () => import('./RollbackRun'),
    },
    props: {
      isRoot: Boolean,
      item: Object,
      hover: Boolean,
    },
    data: () => ({
      serviceKeys,
    }),
    computed: {
      rollbackItem() {
        return this.item && this.item.rollbackDetail
      },
      isSurveyData() {
        return this.item && (SERVICE_LINKS.ECOSURVEY_EDD_INGESTION == this.item.serviceName)
      },
      keysToDisplay() {
        if(this.item && (SERVICE_LINKS.ECOSURVEY_EDD_INGESTION == this.item.serviceLink)) {
          return surveyDataKeys
        }
        return serviceKeys
      },
    },
    methods: {
      pluralize,
      getMediaTypeIcon,
    },
  }
</script>